package com.merkost.handpass.admin.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext

@Page("/reports")
@Composable
fun ReportsRedirectPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        ctx.router.navigateTo("/?source=REPORTS")
    }
}
